package com.artvending.warden

val APP_VERSION = "1.35"